<template>
  <page>
    <template slot="content">
      <template>
        <list-group :title="'購入／取り扱い注意事項'">
          <list-item :spanText="'Q. '" :text="'WeBand3SCの取り扱い注意事項'" :urlName="'Help33'"></list-item></list-item>
        </list-group>
      </template>
    </template>
  </page>
</template>

<script>
  import ListGroup from '@/components/ListGroup'
  import ListItem from '@/components/ListItem'
  import Tab from '@/components/Tab'
  import TabBtn from '@/components/TabBtn'
  import TabContent from '@/components/TabContent'
  import Page from '@/components/Page'

  export default {
    name: 'HelpPage',
    components: {
      ListGroup,
      ListItem,
      Tab,
      TabBtn,
      TabContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/HelpCategory31.vue